// src/stone/icons/PapoDeBalcao.tsx
import { jsx } from "react/jsx-runtime";
var PapoDeBalcao = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M10 .01 17.435 8h2.49C22.2 8 24.001 9.89 24 12.164V24H0V12.162C0 9.889 1.8 8 4.077 8H10zm2 5.085V10H4.077C2.956 10 2 10.943 2 12.162V22h20v-9.837c.001-1.22-.954-2.163-2.076-2.163h-3.36z" })
  }
);
var PapoDeBalcao_default = PapoDeBalcao;

export {
  PapoDeBalcao,
  PapoDeBalcao_default
};
